import { User } from "@/CodegenTypes";


export const canSeeDdPopl = (user?: User | null) => {
    return (user?.ddPlaceoutPl || 0) > 0;
}